import Content from '@/components/toolbox/help/Content'
import Vue from 'vue'

class HelpList {
  constructor ($store) {
    // wir wollen die vuex watcher los werden
    this.title = null
    this.parentChain = []
    this.activeEntry = null
    this.loaded = false
    this.loadingPromise = this.init($store)
  }

  async init ($store) {
    if (this.loaded) {
      return this
    }

    let data = []
    if ($store.getters['help/getList'].length > 0) {
      data = $store.getters['help/getList']
    } else {
      data = await $store.dispatch('help/fetchList')
    }
    Vue.set(this, 'children', data)

    this.loaded = true
    return this
  }

  getToolboxTabs () {
    return {
      edit: {
        tab: Content,
        icon: 'content'
      }
    }
  }
}

export default HelpList
